import styled from '../../../../theme/theme';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';

export const ToggleButton = styled(Button)(({ theme }) => ({
  '&:not(.disabled):active, &[aria-pressed=true]': {
    backgroundColor: theme.colors.neutral['300'],

    '&:not(.disabled):focus': {
      background: theme.colors.neutral['300'],
    },
  },
}));
